import {
  AdditionalRoom,
  AvailableFloor,
  Client,
  Department,
  ExcludedDayRange,
  ResearchStatus,
  SpaceType,
  TeamLocation
} from '@features/researches/models/research.model';
import { Timezone } from '@features/researches/models/timezone.model';

export interface ResearchCreator extends ResearchCreatorSteps {
  previousStatus: ResearchStatus;
}

export interface ResearchCreatorSteps {
  details: CreatorResearchDetails;
  workspace: CreatorWorkspaceDetails;
  structure: CreatorOrganisationalStructure;
  utilization: CreatorSpaceUtilization;
  plan: CreatorSpacePlan;
}

export interface CreatorStepBase {
  status: StepStatus;
}

export interface CreatorResearchDetails extends CreatorStepBase {
  id?: number;
  name: string;
  startDate: string;
  endDate: string;
  timezone: Timezone;
  funder: string;
  excludedDayRanges: ExcludedDayRange[];
  companyLogoFile: File | null;
  client: Client;
}

export interface CreatorWorkspaceDetails extends CreatorStepBase {
  buildingName: string;
  avgSpacePerDesk: number;
  avgSpaceCost: number;
  availableFloors: AvailableFloor[];
  officeBenchmark: number;
  openSpaceBenchmark: number;
  workdays: string[];
  officeHours: {
    start: string;
    end: string;
  };
  minDailyDeskCapacity: number;
  avgDailyDeskCapacity: number;
}

export interface CreatorOrganisationalStructure extends CreatorStepBase {
  departments: Department[];
}

export interface CreatorSpaceUtilization extends CreatorStepBase {
  byTeams: TeamLocation[];
  additionalRooms: AdditionalRoom[];
}

export interface CreatorSpacePlan extends CreatorStepBase {
  spacePlanFileName?: string;
  spacePlanFile?: File;
  spacePlanFileValid: boolean;
}

export interface StepDetails {
  name: CreatorStep;
  status: StepStatus;
}

export enum StepStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  TO_DO = 'TO_DO'
}

export enum CreatorStep {
  DETAILS = 'details',
  WORKSPACE = 'workspace',
  STRUCTURE = 'structure',
  UTILIZATION = 'utilization',
  PLAN = 'plan'
}

export enum Workdays {
  MON = 'mon',
  TUE = 'tue',
  WED = 'wed',
  THU = 'thu',
  FRI = 'fri',
  SAT = 'sat',
  SUN = 'sun'
}

export interface AdditionalRoomForSpacePlan {
  id: string;
  floor: string;
  spaceType: SpaceType;
  name: string;
}

export interface UtilisedSpace {
  id: string;
  floor: string;
  spaceType: SpaceType;
  teamName: string;
  departmentName: string;
}
